import axios from "axios";
import { SERVER_API_URL } from "../apis/index";

const axiosInstance = axios.create({
  baseURL: SERVER_API_URL,
  headers: {}
});

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("idToken");
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const AxiosHttp = axiosInstance;
